'use client'

import { useCallback, useState } from 'react'
import Popover from '@dustin-web/microsite-components/src/popover'
import Button from '@dustin-web/microsite-components/src/button'
import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'
import { isNotNullOrUndefined } from '@dustin-web/microsite-data/src/utils'
import { storeCartDetails } from '@dustin-web/product-components/src/utils/cart-local-storage'
import scrollToTop from '@dustin-web/microsite-components/src/utils/scroll-to-top'
import { ProductDigitalData } from '@dustin-web/product-components/src/utils/product-digital-data'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import Icon from '@dustin-web/microsite-components/src/icon'
import CreateFavoriteListButton from './create-favorite-list-button'
import ExportShoppingCartButton from './export-shoppingcart'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'

const UtilityRow = () => {
  const { emptyCart, cartItems, totalPriceExcludingVat } = useShoppingCart({
    withRequiredEndUserInformation: true,
  })
  const [showEmptyCartDialog, setShowEmptyCartDialog] = useState(false)
  const { translate } = useI18n()
  const { currencyCode } = useSiteContext()

  const onEmptyCart = useCallback(() => {
    const products = cartItems
      .map(x => {
        return x.product ? { ...x.product, quantity: x.quantity } : null
      })
      .filter(isNotNullOrUndefined)

    storeCartDetails({ action: 'REMOVE_ALL' })

    ProductDigitalData.pushRemoveFromCart(
      products,
      0,
      translate,
      currencyCode,
      totalPriceExcludingVat,
      'shoppingCartPage'
    )
    scrollToTop()
    emptyCart()
    setShowEmptyCartDialog(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(cartItems)])

  return (
    <div className="u-mb-8 u-mb-xl-40 d-flex flex-column flex-lg-row align-items-start d-print-none">
      <Popover
        popoverClassName="u-col-3 u-w-sm-auto"
        positions={['bottom-free']}
        open={showEmptyCartDialog}
        onToggle={setShowEmptyCartDialog}
        closeOnOutsideClick={true}
        content={
          <>
            <p className="u-fs-14 u-mb-16 u-pr-24">
              {translate('Cart_AreYouSureYouWantToRemoveAllProducts')}
            </p>
            <div className="d-flex flex-column-reverse flex-sm-row">
              <Button
                text={translate('Cart_UndoRemove')}
                className="u-mb-0 u-w-100"
                onClick={() => setShowEmptyCartDialog(false)}
              />
              <Button
                text={translate('Cart_ConfirmRemove')}
                onClick={() => {
                  onEmptyCart()
                }}
                className="u-mb-8 u-mb-sm-0 u-w-100"
                primary
              />
            </div>
          </>
        }>
        <button
          className="button-stripped u-decoration-none u-mb-lg-0 u-mr-16"
          type="button"
          onClick={() => setShowEmptyCartDialog(true)}>
          <Icon name="trash-bin" className="u-mr-8 i-16" />
          <span>{translate('Cart_EmptyCart')}</span>
        </button>
      </Popover>

      <CreateFavoriteListButton
        className="u-mr-16"
        productsInCart={cartItems
          .map(item => {
            return item.product
          })
          .filter(isNotNullOrUndefined)}
      />

      <ExportShoppingCartButton />
    </div>
  )
}

export default UtilityRow
